export default {
  methods: {
    transformAllAverageTimes: function (data) {
      const transformedData = [];
      const {
        answerTillSendToDispatch,
        answerTillEndCall,
        receiveTillDispatch,
        answerTillDispatch,
        dispatchTillMoveFromStation,
        dispatchTillMoveFromStationFence,
        answerTillArriveToLocation,
        answerTillArriveToLocationFence,
        arriveToLocationTillMoveFromLocation,
        arriveToLocationTillMoveFromLocationFence,
        moveFromLocationTillArriveToHospital,
        moveFromLocationTillArriveToHospitalFence,
        arriveToHospitalTillMoveFromHospital,
        arriveToHospitalTillMoveFromHospitalFence,
      } = data;
      const answerTillSendToDispatchTime = this.convertFullTimeToMMss(answerTillSendToDispatch);
      const answerTillEndCallTime = this.convertFullTimeToMMss(answerTillEndCall);
      const receiveTillDispatchTime = this.convertFullTimeToMMss(receiveTillDispatch);
      const answerTillDispatchTime = this.convertFullTimeToMMss(answerTillDispatch);
      const dispatchTillMoveFromStationTime = this.convertFullTimeToMMss(
        dispatchTillMoveFromStation,
      );
      const dispatchTillMoveFromStationFenceTime = this.convertFullTimeToMMss(
        dispatchTillMoveFromStationFence,
      );
      const answerTillArriveToLocationTime = this.convertFullTimeToMMss(answerTillArriveToLocation);
      const answerTillArriveToLocationFenceTime = this.convertFullTimeToMMss(
        answerTillArriveToLocationFence,
      );
      const arriveToLocationTillMoveFromLocationTime = this.convertFullTimeToMMss(
        arriveToLocationTillMoveFromLocation,
      );
      const arriveToLocationTillMoveFromLocationFenceTime = this.convertFullTimeToMMss(
        arriveToLocationTillMoveFromLocationFence,
      );
      const moveFromLocationTillArriveToHospitalTime = this.convertFullTimeToMMss(
        moveFromLocationTillArriveToHospital,
      );
      const moveFromLocationTillArriveToHospitalFenceTime = this.convertFullTimeToMMss(
        moveFromLocationTillArriveToHospitalFence,
      );
      const arriveToHospitalTillMoveFromHospitalTime = this.convertFullTimeToMMss(
        arriveToHospitalTillMoveFromHospital,
      );
      const arriveToHospitalTillMoveFromHospitalFenceTime = this.convertFullTimeToMMss(
        arriveToHospitalTillMoveFromHospitalFence,
      );

      function pushToTranformedAverageTimes() {
        transformedData.push(
          {
            id: 1,
            time: answerTillSendToDispatchTime,
            title: 'زمان تعیین تکلیف تریاژ تلفنی',
            showTime:false
          },
          { id: 2, time: answerTillEndCallTime, title: 'زمان تریاژ تلفنی', showTime:false },
          { id: 3, time: receiveTillDispatchTime, title: 'زمان فراخوان' , showTime:false},
          { id: 4, time: answerTillDispatchTime, title: 'زمان کنش', showTime:false },
          {
            id: 5,
            time: dispatchTillMoveFromStationTime,
            fence: dispatchTillMoveFromStationFenceTime,
            title: 'زمان واکنش',
            showTime:true
          },
          {
            id: 6,
            time: answerTillArriveToLocationTime,
            fence: answerTillArriveToLocationFenceTime,
            title: 'زمان پاسخگویی',
             showTime:true
          },
          {
            id: 7,
            time: arriveToLocationTillMoveFromLocationTime,
            fence: arriveToLocationTillMoveFromLocationFenceTime,
            title: 'زمان صحنه',
             showTime:true
          },
          {
            id: 8,
            time: moveFromLocationTillArriveToHospitalTime,
            fence: moveFromLocationTillArriveToHospitalFenceTime,
            title: 'زمان انتقال',
             showTime:true
          },
          {
            id: 9,
            time: arriveToHospitalTillMoveFromHospitalTime,
            fence: arriveToHospitalTillMoveFromHospitalFenceTime,
            title: 'زمان ماندگاری در بیمارستان',
             showTime:true
          },
        );
      }
      pushToTranformedAverageTimes();
      return transformedData;
    },
    transformStationAverageTimes: function (data) {
      return [...data]?.map(
        ({
          receiveTillDispatch,
          answerTillDispatch,
          dispatchTillMoveFromStation,
          dispatchTillMoveFromStationFence,
          answerTillArriveToLocation,
          answerTillArriveToLocationFence,
          arriveToLocationTillMoveFromLocation,
          arriveToLocationTillMoveFromLocationFence,
          moveFromLocationTillArriveToHospital,
          moveFromLocationTillArriveToHospitalFence,
          arriveToHospitalTillMoveFromHospital,
          arriveToHospitalTillMoveFromHospitalFence,
          station,
        }) => {
          return {
            station,
            receiveTillDispatch: {
              time: this.convertFullTimeToMMss(receiveTillDispatch),
            },
            answerTillDispatch: {
              time: this.convertFullTimeToMMss(answerTillDispatch),
            },
            dispatchTillMoveFromStation: {
              time: this.convertFullTimeToMMss(dispatchTillMoveFromStation),
              fence: this.convertFullTimeToMMss(dispatchTillMoveFromStationFence),
            },
            answerTillArriveToLocation: {
              time: this.convertFullTimeToMMss(answerTillArriveToLocation),
              fence: this.convertFullTimeToMMss(answerTillArriveToLocationFence),
            },
            arriveToLocationTillMoveFromLocation: {
              time: this.convertFullTimeToMMss(arriveToLocationTillMoveFromLocation),
              fence: this.convertFullTimeToMMss(arriveToLocationTillMoveFromLocationFence),
            },
            moveFromLocationTillArriveToHospital: {
              time: this.convertFullTimeToMMss(moveFromLocationTillArriveToHospital),
              fence: this.convertFullTimeToMMss(moveFromLocationTillArriveToHospitalFence),
            },
            arriveToHospitalTillMoveFromHospital: {
              time: this.convertFullTimeToMMss(arriveToHospitalTillMoveFromHospital),
              fence: this.convertFullTimeToMMss(arriveToHospitalTillMoveFromHospitalFence),
            },
          };
        },
      );
    },
    convertFullTimeToMMss: function (time) {
      let minuts = 0;
      let seconds = 0;
      const timeArr = time.split(':');
      const dayAndHourArr = timeArr[0].split('.');
      convertDayToMinuts();
      function convertDayToMinuts() {
        if (dayAndHourArr?.length === 2) {
          const days = +dayAndHourArr[0];
          const hours = +dayAndHourArr[1];
          const timeMinutes = +timeArr[1];
          minuts = days * 24 * 60 + hours * 60 + timeMinutes;
        } else {
          const hours = +dayAndHourArr[0];
          const timeMinutes = +timeArr[1];
          minuts = hours * 60 + timeMinutes;
        }
      }
      seconds = timeArr[2].split('.')[0];
      return `${minuts.toString()?.padStart(2, '0')}:${seconds.toString()?.padStart(2, '0')}`;
    },
  },
};
